export default __webpack_public_path__ + "static/SRUS LF320 - Product Specifications & Technical Data-af90cf1f1ee4f9f05ae4837b20711646.pdf";